import { Getters } from 'vuex-smart-module';
import { CoreState } from '@/store/core/state';
import { protectionType } from '@/types/writeup';

export class CoreGetters extends Getters<CoreState> {
	get isModalOpen() {
		return this.state.isModalOpen;
	}

	get initData() {
		return this.state.initData;
	}

	get styleVariables() {
		return this.state.styleVariables;
	}

	get config() {
		return this.state.config;
	}

	get apiKey() {
		return this.state.config.apiKey;
	}

	get isSettingsLoaded() {
		return this.state.settingsLoaded;
	}

	get settings() {
		return this.state.settings;
	}

	get website() {
		return this.state.website;
	}

	get dealer() {
		return this.state.dealer;
	}

	get websiteSettings() {
		return this.state.websiteSettings;
	}

	get optionProvider() {
		let provider: string;

		if (this.state.websiteSettings.protection.fiService === 1) {
			provider = protectionType.FAndI;
		} else {
			provider = protectionType.Desking;
		}

		return provider;
	}

	get isError() {
		return this.state.isError;
	}

	get originSource() {
		return this.state.originSource;
	}
}
